import React from 'react';

import { handleLink } from 'components/storefront/editor/easyblocks-page/parser/utils';

import { replaceProps, applyAttributes } from './utils';

/** @typedef {import('domhandler').Element} Element */

function processLink(theme) {
  return {
    /** @param {Element} node */
    shouldProcessNode(node) {
      return node.name === 'a';
    },
    /** @param {Element} node */
    processNode(node, children, index) {
      applyAttributes(
        node,
        handleLink(
          theme,
          node.attribs?.href,
          node.attribs?.style,
          node.attribs?.form,
        ),
      );
      replaceProps(node);

      return React.createElement(node.name, node.attribs, ...children);
    },
  };
}

export default processLink;
